import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { ProcurementAxios } from "api/ProcurementAxios";
import { WarehouseAxios } from "api/WarehouseAxios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";
import { parse } from "date-fns";
import { convertLocalDateToUTC } from '../../../../helpers/DateUtils/dateTimezoneUtils';
const BASE_URL = "/packing/";

const convertToUTC = (dateStr: string | undefined): string => {
  if (!dateStr) return "";
  try {
    let localDateStr = "";
    
    // Try parsing yyyy-MMM-dd format first (e.g., "2026-Jan-14")
    let parsed = parse(dateStr, "yyyy-MMM-dd", new Date());
    if (!isNaN(parsed.getTime())) {
      // Convert to YYYY-MM-DD format
      const year = parsed.getFullYear();
      const month = String(parsed.getMonth() + 1).padStart(2, "0");
      const day = String(parsed.getDate()).padStart(2, "0");
      localDateStr = `${year}-${month}-${day}`;
    }
    // Try parsing YYYY-MM-DD format (e.g., "2026-01-14")
    else if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      localDateStr = dateStr;
    }
    // Fallback: try parsing as ISO string - if already UTC, return as is
    else if (dateStr.includes("T") || dateStr.includes("Z")) {
      // Already in UTC format, return as is
      return dateStr;
    }
    
    // Convert local date string to UTC ISO string
    if (localDateStr) {
      return convertLocalDateToUTC(localDateStr);
    }
    
    return "";
  } catch {
    return "";
  }
};

export const fetchWarehousePacking = createAsyncThunk(
  "warehouse/fetchWarehousePacking",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    warehouse_id,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    warehouse_id?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }
    if (warehouse_id) {
      params.append('warehouse_id', warehouse_id)
    }

    const filterPayload = FilterBuilder(filters ?? []);

    const body = {
      filters: filterPayload,
    };


    const response: any = await WarehouseAxios.post(
      `${API_ENDPOINT?.WAREHOUSE.PACKING.LIST}?${params.toString()}`,
      body
    );

    return {
      data: response?.data?.data || [],
      rowCount: response?.data?.count || 0,
    };
  }
);

export const fetchWarehousePackingIssuePacking = createAsyncThunk(
  "warehouse/fetchWarehousePackingIssuePacking",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await WarehouseAxios.get(
        `${BASE_URL}/issue-packing/create/${id}/`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const exportPurchaseRequestCSV = async () => {
  const response = await ProcurementAxios.get(
    "/purchase-request/list/?export=csv",
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "purchaseRequest.csv",
  };
};

export const fetchCreatePackingPreview = createAsyncThunk(
  "warehouse/fetchCreatePackingPreview",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await WarehouseAxios.get(
        `${API_ENDPOINT?.WAREHOUSE.PACKING.FetchPackingPreview(id)}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const FetchPackingById = createAsyncThunk(
  "sales_order/fetchPackingById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await WarehouseAxios.get(
        API_ENDPOINT?.WAREHOUSE?.PACKING?.DETAIL(id)
      );
      console.log("response in line 225 fetchProductSalesOrderById thunk", response);
      return response?.data?.data || response?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const exportIssuePackingCSV = async ({
  search,
  warehouse_id,
  filters,
}: {
  search?: string;
  warehouse_id?: string;
  filters?: {
    filterField: string;
    filterValue: any;
  }[];
}) => {
  const params = new URLSearchParams();

  if (search) params.append("search", search);
  if (warehouse_id) params.append("warehouse_id", warehouse_id);

  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await WarehouseAxios.post(
    `${API_ENDPOINT?.WAREHOUSE.PACKING.EXPORT}?${params.toString()}`,
    body,
    { responseType: "blob" }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") ||
      `Issue_Packing_${new Date().toISOString().split("T")[0]}.csv`,
  };
};

// Revert "Issue For Packing" for a specific sales_order_product_id
export const handleRevertIssueForPacking = createAsyncThunk(
  "sales_order/revertIssueForPacking",
  async (sales_order_product_id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        API_ENDPOINT?.WAREHOUSE?.PACKING?.REVERT(sales_order_product_id)
      );

      console.log(
        "Revert Issue For Packing response:",
        response?.data
      );

      return response?.data?.data || response?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
